import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

//antd components
import { Modal, Button } from 'antd';

//styles
import './style.scss';


function ModalChangePresence({
  loading,
  okHandle,
  cancelHandle,
  content,
  isOpen,
  // actions
  setOpen,
  // default props
  className,
  children,
}) {
  const mainClassName = classNames("modal-modifier", className);
  const { t, i18n } = useTranslation();

  const handleOk = useCallback(() => {
    !!okHandle && okHandle();
    setOpen(!isOpen);
  }, [okHandle, isOpen]);

  const handleCancel = useCallback(() => {
    !!cancelHandle && cancelHandle();
    setOpen(!isOpen);
  }, [cancelHandle, isOpen]);

  const renderModal = useMemo(
    () => (
      <Modal
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="modal-modifier-wrapper"
      >
        <div className="wrapper-content">
          <h3 className="content-title">{t("attendances.modifyingAttendances")}</h3>

          {(content || children) && (
            <div
              className="content-text"
              dangerouslySetInnerHTML={{
                __html: !!(content || children) && (content || children) || t("attendances.hasAttendanceMsg")
              }}
            />
          )}
        </div>
        <div className="wrapper-btn">
          <Button onClick={handleOk} className="btn-change">
            {t("attendances.modifyingAttendances")}
          </Button>
          <Button onClick={handleCancel} className="btn-return">
            {t("common.backTo")}
          </Button>
        </div>
      </Modal>
    ),
    [isOpen, content, children, i18n?.language],
  );

  return <div className={mainClassName}>{renderModal}</div>;
}

ModalChangePresence.defaultProps = {
  isOpen: false,
  loading: false
};
ModalChangePresence.propTypes = {
  content: PropTypes.string,
  okHandle: PropTypes.func,
  cancelHandle: PropTypes.func,
};

export default ModalChangePresence;
